import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "row-12 text-end mb-5" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn btn-primary btn-sm",
    "data-bs-toggle": "modal",
    "data-bs-target": "#modal_add_product"
  }, " Add Products ")
], -1)
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "col-12 mt-5" }
const _hoisted_4 = {
  key: 1,
  class: "card card-flush pt-3 mb-5 mb-lg-5"
}
const _hoisted_5 = { class: "card-body pt-0" }
const _hoisted_6 = { class: "table-responsive" }
const _hoisted_7 = {
  class: "table align-middle table-row-dashed fs-6 fw-bold gy-4",
  id: "kt_subscription_products_table"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "text-start text-gray-600 fw-bold fs-7 gs-0" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-70px" }, "Name"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-70px" }, "Description"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-70px" }, "Image"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-70px" }, "Price"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-70px text-end" }, "Actions")
  ])
], -1)
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "text-end" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "svg-icon svg-icon-3" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "svg-icon svg-icon-3" }
const _hoisted_15 = {
  key: 0,
  class: "overlay-layer card-rounded bg-dark bg-opacity-5 align-middle"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border text-primary",
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...")
], -1)
const _hoisted_17 = [
  _hoisted_16
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_alert = _resolveComponent("el-alert")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_AddProductModal = _resolveComponent("AddProductModal")!
  const _component_EditProductModal = _resolveComponent("EditProductModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    (_ctx.getIsDataEmpty)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_el_alert, {
              title: "Add Products",
              type: "success",
              effect: "light",
              description: "Add products and services for this merchant.",
              "show-icon": ""
            })
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("table", _hoisted_7, [
                _hoisted_8,
                _createElementVNode("tbody", {
                  class: _normalizeClass(["text-gray-800 fs-7", [_ctx.loading && 'overlay overlay-block']])
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.products, (product, index) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      class: _normalizeClass(index % 2 === 0 ? 'odd' : 'even'),
                      key: index
                    }, [
                      _createElementVNode("td", null, _toDisplayString(product.product_name), 1),
                      _createElementVNode("td", null, _toDisplayString(product.product_description), 1),
                      _createElementVNode("td", null, [
                        _createElementVNode("img", {
                          src: product.product_url,
                          class: "h-40px align-self-center",
                          alt: ""
                        }, null, 8, _hoisted_9)
                      ]),
                      _createElementVNode("td", null, _toDisplayString(product.product_price), 1),
                      _createElementVNode("td", _hoisted_10, [
                        _createElementVNode("a", {
                          class: "btn btn-icon btn-flex btn-active-light-primary w-30px h-30px me-3",
                          "data-bs-toggle": "tooltip",
                          title: "Remove",
                          "data-kt-action": "product_remove",
                          "data-bs-original-title": "Delete",
                          onClick: ($event: any) => (_ctx.onRemove(index))
                        }, [
                          _createElementVNode("span", _hoisted_12, [
                            _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen027.svg" })
                          ])
                        ], 8, _hoisted_11),
                        _createElementVNode("a", {
                          class: "btn btn-icon btn-flex btn-active-light-primary w-30px h-30px me-3",
                          "data-bs-toggle": "modal",
                          "data-bs-target": "#modal_edit_product",
                          onClick: ($event: any) => (_ctx.onEdit(index))
                        }, [
                          _createElementVNode("span", _hoisted_14, [
                            _createVNode(_component_inline_svg, { src: "/media/icons/duotune/art/art005.svg" })
                          ])
                        ], 8, _hoisted_13)
                      ])
                    ], 2))
                  }), 128)),
                  (_ctx.loading)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, _hoisted_17))
                    : _createCommentVNode("", true)
                ], 2)
              ])
            ])
          ])
        ])),
    _createVNode(_component_AddProductModal, {
      onSubmit: _ctx.onNewProductSubmit,
      products: _ctx.products
    }, null, 8, ["onSubmit", "products"]),
    _createVNode(_component_EditProductModal, {
      onSubmit: _ctx.onNewProductSubmit,
      products: _ctx.products,
      selectedIndex: _ctx.selectedIndex
    }, null, 8, ["onSubmit", "products", "selectedIndex"])
  ], 64))
}